const data = [
    {
      id: 1,
      image: "images/Figma.png",
      title: "Figma",
    },
    {
      id: 2,
      image: "images/Canva.png",
      title: "Canva",
    },
    {
      id: 3,
      image: "images/insh.png",
      title: "InShot and VN",
    },
    {
      id: 4,
      image: "images/snapseed.png",
      title: "Snapseed and LightRoom",
    },
      {
      id: 5,
      image: "images/semrush.png",
      title: "SemRush",
    },
   
  ]
  export default data